const GET_MESSAGE = "users/GET_MESSAGE"
export default {
  GET_MESSAGE,
}
